import { SwitchProps } from "@mantine/core";

import { StyledSwitch } from "./switch.styles";

export const SliderButton = (props: SwitchProps) => {
  return <StyledSwitch {...props} />;
};
